import { adminAreasFor } from '../lib/access.js';

/**
 * The admin home (docs/admin-area.md): quick links to every admin area this
 * person may open — the answer to "what is the first thing an admin does
 * here on a normal morning".
 */
export async function renderAdminHome() {
  const el = document.getElementById('view-admin');
  const access = window.__access;
  const areas = adminAreasFor(access);

  if (!areas.length) {
    el.innerHTML = `<div class="page-header"><h1>Admin</h1><p>The admin area is not switched on for you.</p></div>`;
    return;
  }

  const groups = ['Admin', 'Management', 'Learner pay', 'HR'].map((g) => ({ heading: g, items: areas.filter((a) => a.group === g) })).filter((g) => g.items.length);

  el.innerHTML = `
    <div class="page-header">
      <h1>Admin</h1>
      <p>Running Londmarx lives here, so the Work side stays the daily work. Use the switch at the top of the menu to go back and forth.</p>
    </div>
    ${groups.map((g) => `
      <div class="section-title">${g.heading}</div>
      <div class="admin-cards">
        ${g.items.map((a) => `
          <a href="#/${a.view}" class="admin-card" data-view="${a.view}">
            <span class="admin-card-title">${a.label}</span>
            <span class="admin-card-blurb">${a.blurb}</span>
          </a>`).join('')}
      </div>`).join('')}
  `;
}
